(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationPurchaseInsurance',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var label_name          = 'reservationpurchaseinsurance';
		var responsible_client  = $('#' + label_name + '-client_id');
		var choose_cc           = $('#' + label_name + '-client_credit_card_id');
		var selected_cc_widget  = $('.selected-cc');
		var new_cc_info         = $('.new-cc-details');
		var add_cc_to_profile   = $('.add-credit-card');
		var make_primary_cc     = $('.make-primary-cc');
		var clear_cc_fields     = $('.clear-cc-fields');
		var clear_cc_fields_btn = $('.clear-cc-fields-btn');
		var fulfillment_method  = $('#' + label_name + '-fulfillment_method');

		// when the resposible client changes
		responsible_client.change(function onResponsibleClientChange()
		{
			var client_id = $(this).val();
			var selected_credit_card = choose_cc.val();

			// clear card options
			populateClientCreditCards();

			// If credit card is enter new card
			if (selected_credit_card === 'new') {
				choose_cc.val('new'); // set back to 'new'
			} else if (selected_credit_card.match(/\d+/)) {
				hideExistingCCFields();
				clearCreditCardFields();
				selected_cc_widget.empty();
			}

			if (client_id === 'other') {
				$('.existing-client').toggleClass('hidden');
				$('.responsible-client').toggleClass('hidden');
				return;
			}

			if (client_id) {
				populateClientCreditCards(client_id);
				updateFulfillmentMethod(client_id);
			}
		});

		// when choosing a credit card
		choose_cc.change(function onCreditCardChange()
		{
			var credit_card_id  = $(this).val();
			var url             = '/ClientCreditCards/get/' + credit_card_id;
			var cardholder_name = null;

			if (credit_card_id) {
				if (credit_card_id === 'new') {
					// show CC fields
					showExistingCCFields();

					// show new CC details portion
					new_cc_info.removeClass('hidden');
					add_cc_to_profile.removeClass('hidden');
					clear_cc_fields.removeClass('hidden');

					// hide selected CC details (if visible)
					selected_cc_widget.empty();

					// populate CC name field
					cardholder_name = responsible_client.children(':selected').text();

					if (responsible_client.val() === 'other') {
						$('#' + label_name + '-cardholder_name').val('');
					} else {
						$('#' + label_name + '-cardholder_name').val(cardholder_name);
					}

					return;
				}

				// show CC fields
				showExistingCCFields();

				// hide new CC details
				new_cc_info.addClass('hidden');
				add_cc_to_profile.addClass('hidden');
				make_primary_cc.addClass('hidden');
				clear_cc_fields.addClass('hidden');

				// populate CC fields
				Adzuki.Ajax.get(url + '/1').then(function getCreditCardSuccess(credit_card)
				{
					var exp_date  = moment(credit_card.expiration, 'YYYY-MM-DD');
					var exp_year  = exp_date.year();
					var exp_month = exp_date.month() + 1;

					if (exp_month < 10) {
						exp_month = '0' + String(exp_month);
					}

					$('#' + label_name + '-cardholder_name').val(credit_card.name);
					$('#' + label_name + '-credit_card_type_id').val(credit_card.credit_card_type_id);
					$('#' + label_name + '-credit_card_type_id').trigger('change');

					if (credit_card.number_token === null) {
						$('#' + label_name + '-credit_card_number').removeAttr('data-token');

						$('.cc-num-ss-link').addClass('hidden');
						$('.cc-num-span').removeClass('input-group');

						$('#' + label_name + '-credit_card_number').val('').focus();
					} else {
						$('.cc-num-span').addClass('input-group');
						$('.cc-num-ss-link').removeClass('hidden');

						$('#' + label_name + '-credit_card_number').attr('data-token', credit_card.number_token);

						Adzuki.SecureStorage.detokenize({
							secure_storage_tokens: [credit_card.number_token],
							success              : function success(plain_texts) {
								$('#' + label_name + '-credit_card_number').val(plain_texts[0]);
							}
						});
					}

					if (Adzuki.is_mobile) {
						$('#' + label_name + '-credit_card_expiration').val(exp_year + '-' + exp_month + '-01');
					} else {
						$('#' + label_name + '-credit_card_expiration')
							.data('DateTimePicker')
							.date(moment(exp_year + '-' + exp_month + '-01', 'YYYY-MM-DD'));
					}

					// for AMEX cards, pre-select the AMEX card type
					if (parseInt(credit_card.credit_card_type_branch_id)) {
						$('#' + label_name + '-credit_card_type_branch_id')
							.val(credit_card.credit_card_type_branch_id);
					}
				});

				// show CC info
				Adzuki.Ajax.get(url).then(function getCreditCardSuccess(credit_card)
				{
					selected_cc_widget.empty().append(credit_card);
				});
			} else {
				// hide CC fields
				hideExistingCCFields();
				selected_cc_widget.empty();

				// hide new CC details
				new_cc_info.addClass('hidden');
				add_cc_to_profile.addClass('hidden');
				make_primary_cc.addClass('hidden');
				clear_cc_fields.addClass('hidden');
			}
		});

		// when the select drop down of cardholder country changes
		$('#' + label_name + '-cardholder_country_id').change(function onCountryChange()
		{
			var country_id = $(this).val();

			Adzuki.Ajax.get('/States/getByCountryId/' + country_id).then(function onStatesSuccess(states)
			{
				// show states only for US and Canada
				if (country_id === '183' || country_id === '31') {
					$('.cardholder-state').removeClass('hidden');
					populateStates(states);
				} else {
					$('.cardholder-state').addClass('hidden');
				}
			});
		});

		// setup existing client typeahead
		Adzuki.Typeahead(
			$('.existing-client-typeahead'),
			function source(term, display, $self) {
				var responsible_client_options = $('#' + label_name + '-client_id option');
				var current_passengers = responsible_client_options
					.map(function passenger()
					{
						return $(this).val();
					}).get();

				Adzuki.Ajax.get('/Searches/client/' + term)
					.then(function result(response)
					{
						$.each(response, function onEachClient(i, client) {
							if (
								client
								&& $.inArray(client.id, current_passengers) !== -1
							) {
								response.splice(i, 1);
							}
						});

						$self.removeClass('ajax-spinner');
						display(response);
					});
			},
			function select(item, $self, typeahead) {
				Adzuki.CustomConfirm({
					body   : 'You have selected a cardholder as a responsible client for the payment that is not currently listed as a passenger on the reservation. Please make sure you have them sign and send back the credit card authorization form for this payment. Are you sure you want to do this?',
					confirm: function agentConfirmedClientChange() {
						typeahead.setHiddenValue(item.id);
						populateClientCreditCards(item.id);
						updateFulfillmentMethod(item.id);
					},
					cancel: function agentCancelledClientChange() {
						$('.close-client-typeahead').trigger('click');
					}
				});
			}
		);

		// clicking on the close button to reset the client typeahead
		$('.close-client-typeahead').click(function onCloseTypeahead(event) {
			event.preventDefault();

			$('.existing-client').toggleClass('hidden');
			$('.responsible-client').toggleClass('hidden');

			$('#' + label_name + '-existing_client_id').val('');
			$('.existing-client-typeahead').val('');

			responsible_client.val(responsible_client.find('option').first().val());
			responsible_client.trigger('change');
		});

		// clicking on "Clear Credit Card Fields"
		clear_cc_fields_btn.click(function onClearCCFieldsClick(event)
		{
			event.preventDefault();
			clearCreditCardFields();
		});

		// when the credit card type changes
		// if AMEX, select an AMEX type
		$('#' + label_name + '-credit_card_type_id').change(function onCCTypeChange()
		{
			var credit_card_type = parseInt($(this).val());

			if (credit_card_type === 1) {
				$('.amex-card-type').removeClass('hidden');
			} else {
				$('.amex-card-type').addClass('hidden');
				$('#' + label_name + '-credit_card_type_branch_id').val('');
			}
		});

		// enable make primary checkbox when checking the add to client profile checkbox
		$('#' + label_name + '-add_credit_card').change(function onCCProfileCheckboxChange(event)
		{
			if ($(this).is(':checked')) {
				make_primary_cc.removeClass('hidden');
			} else {
				make_primary_cc.addClass('hidden');
				make_primary_cc.find('input[type="checkbox"]')
							   .first().prop('checked', false);
			}
		});

		// trigger responsible client change
		responsible_client.trigger('change');

		function clearCreditCardFields()
		{
			$('#' + label_name + '-cardholder_name').val('');
			$('#' + label_name + '-cardholder_address1').val('');
			$('#' + label_name + '-cardholder_address2').val('');
			$('#' + label_name + '-cardholder_city').val('');
			$('#' + label_name + '-cardholder_state_id').val('');
			$('#' + label_name + '-cardholder_zipcode').val('');
			$('#' + label_name + '-cardholder_country_id').val('');
			$('#' + label_name + '-cardholder_credit_card_type_id').val('');
			$('#' + label_name + '-cardholder_credit_card_number').val('');
			$('#' + label_name + '-credit_card_type_id').val('');
			$('#' + label_name + '-credit_card_type_branch_id').val('');
			$('#' + label_name + '-credit_card_expiration').data('DateTimePicker').date(null);
			$('#' + label_name + '-credit_card_number').val('');
		}

		function updateFulfillmentMethod(client_id)
		{
			Adzuki.Ajax.get('/Clients/getClientEmail/' + client_id).then(function onClientEmail(response)
			{
				if (response[client_id]) {
					if ($('#' + label_name + '-fulfillment_method option[value="EMAIL_BOTH"]').length === 0) {
						fulfillment_method.append('<option value="EMAIL_BOTH">Email Agent & Responsible Client</option>');
					}

					fulfillment_method.val('EMAIL_BOTH');
				} else if ($('#' + label_name + '-fulfillment_method option[value="EMAIL_BOTH"]').length !== 0) {
					$('#' + label_name + '-fulfillment_method option[value="EMAIL_BOTH"]').remove();
				}
			});
		}

		function populateClientCreditCards(client_id)
		{
			var url;

			choose_cc
				.empty()
				.append('<option selected="1"></option>')
				.append('<option value="new">-- Enter Credit Card Info --</option>');

			if (client_id) {
				url = '/ClientCreditCards/getCardsByClientId/' + client_id + '/0';

				Adzuki.Ajax.get(url).then(function onCreditCardsSuccess(credit_cards)
				{
					$.each(credit_cards, function onEachCreditCard(credit_card_id, credit_card) {
						var markup = '';
						markup += '<option value="' + credit_card_id + '">';
						markup += credit_card;
						markup += '</option>';

						choose_cc.append(markup);
					});
				});
			}
		}

		function populateStates(states)
		{
			$('#' + label_name + '-cardholder_state_id')
				.empty()
				.append('<option selected="1"></option>');

			$.each(states, function onEachState(id, state_name) {
				var markup = '';
				markup += '<option value="' + id + '">';
				markup += state_name;
				markup += '</option>';

				$('#' + label_name + '-cardholder_state_id').append(markup);
			});
		}

		function showExistingCCFields()
		{
			$('.cardholder-name').removeClass('hidden');
			$('.credit-card-type').removeClass('hidden');
			$('.credit-card-number').removeClass('hidden');
			$('.credit-card-expiration').removeClass('hidden');
		}

		function hideExistingCCFields()
		{
			$('.cardholder-name').addClass('hidden');
			$('.credit-card-type').addClass('hidden');
			$('.amex-card-type').addClass('hidden');
			$('.credit-card-number').addClass('hidden');
			$('.credit-card-expiration').addClass('hidden');
		}
	};

}(jQuery, window.Adzuki || {}));
